import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M7.5 37.499V13.574H15.3675V15.6679H9.59396V35.4051H30.406V15.6679H24.5983V13.574H32.4999V37.499H7.5ZM18.9359 25.7021V7.1145L15.3675 10.6829L13.8654 9.18296L19.9829 3.07617L26.0897 9.18296L24.5983 10.6829L21.0298 7.1145V25.7021H18.9359Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map